import { View } from "react-native";

import { DivProps } from "./Div.types";
import { useClassNames } from "../../../structure";

export default function Div({ children, classNames, id }: DivProps) {
  const style = useClassNames(classNames);
  return (
    <View id={id} style={style}>
      {children}
    </View>
  );
}
